import { gatewayPageBuilder } from "../../../../../gateways/gatewayPageBuilder";

export type PublishPayload = {
  slug: string;
  draftId: string
};

export type PublishResponse = {
  ok: boolean;
  url?: string;
  siteId?: string;
  versionId?: string;
};

export const publishSite = async (payload: PublishPayload): Promise<PublishResponse> => {
  const token = sessionStorage.getItem("token");

  if (!token) {
    throw new Error("No auth token found");
  }

  const { data } = await gatewayPageBuilder.post("page-builder/publish", payload, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  return data;
};
